module.exports = __webpack_public_path__ + "img/go.80420dbe.png";